import api, { sellerApi } from "./api";

/**
 * Create order(s) from active cart
 * @param {Object} payload - Order creation payload
 * @param {string} payload.addressRef - Address ID for shipping
 * @param {string} payload.paymentMethod - Payment method (default: "โอนเงิน")
 * @param {string} payload.shippingMethod - Shipping method (default: "flash")
 * @param {number} payload.shipmentFee - Shipping fee
 * @param {number} payload.discountTotal - Discount amount
 * @returns {Promise} API response with created orders
 */
export const createOrderFromCart = async (payload) => {
    const { data } = await api.post("/api/v1/orders/from-cart", payload);
    return data;
};

export const calculateShippingFeeApi = async (payload) => {
    const { data } = await api.post("/api/v1/orders/calculate-shipping-fee", payload);
    return data;
};

/**
 * Confirm payment for an order (buyer side)
 * @param {string} orderId - Order ID
 * @param {Object} payload - Payment confirmation payload
 * @param {string} payload.note - Optional note for payment
 * @returns {Promise} API response with updated order
 */
export const payOrderByBuyer = async (orderId, payload = {}) => {
    // If payload is FormData (contains files), send as is
    const config = payload instanceof FormData
        ? { headers: { "Content-Type": "multipart/form-data" } }
        : {};
    const { data } = await api.post(`/api/v1/orders/${orderId}/pay`, payload, config);
    return data;
};

export const payOrderByWalletApi = async (orderId) => {
    const { data } = await api.post(`/api/v1/orders/${orderId}/pay-wallet`);
    return data;
};

/**
 * Confirm receiving order (buyer side)
 */
export const receiveOrderApi = async (orderId) => {
    const { data } = await api.put(`/api/v1/orders/${orderId}/receive`);
    return data;
};

/**
 * Get user's paid orders
 * @returns {Promise} API response with orders list
 */
export const getMyOrders = async () => {
    const { data } = await api.get("/api/v1/orders/paid-order");
    return data;
};

/**
 * Get order details by ID
 * @param {string} orderId
 * @returns {Promise} API response with order details
 */
export const getOrderByIdApi = async (orderId) => {
    const { data } = await api.get(`/api/v1/orders/${orderId}`);
    return data;
};

export const getOrderByIdApiBySeller = async (orderId) => {
    const { data } = await sellerApi.get(`/api/v1/orders/${orderId}`);
    return data;
};

/**
 * Get seller's orders
 * @returns {Promise} API response with orders list
 */
export const getMyOrdersApi = async () => {
    const { data } = await sellerApi.get("/api/v1/orders/my-orders");
    return data;
};

/**
 * Update delivery event/note for an order (seller side)
 * @param {string} orderId - Order ID
 * @param {Object} payload - Delivery event payload
 * @param {string} payload.note - Delivery note text
 * @returns {Promise} API response with updated order/event
 */
export const updateOrderDeliveryEventApi = async (orderId, payload = {}) => {
    const { data } = await sellerApi.put(
        `/api/v1/orders/${orderId}/status`,
        payload
    );
    return data;
};

/**
 * Get PromptPay QR Code for an order
 * @param {string} orderId
 * @returns {Promise} API response with QR Data URL
 */
export const getOrderQRCodeApi = async (orderId) => {
    const { data } = await api.get(`/api/v1/orders/${orderId}/qrcode`);    
    return data;
};